// src/components/base/Icon/SvgIcon.tsx
import { SvgDefinition, SvgPaths, SvgName } from './SvgRegistry';
import styles from './SvgIcon.module.css';

interface SvgIconProps {
  name: SvgName;
  size?: number;
  className?: string;
  strokeWidth?: string;
  fill?: string;
  stroke?: string;
  viewBox?: string;
}

export function SvgIcon({
  name,
  size = 24,
  className = '',
  strokeWidth,
  fill,
  stroke,
  viewBox,
}: SvgIconProps) {
  const icon: SvgDefinition | undefined = SvgPaths[name];

  if (!icon) {
    console.warn(`Icon "${name}" not found in registry.`);
    return null;
  }

  const combinedClasses = [styles.svg, className].filter(Boolean).join(' ');
  const resolvedViewBox = viewBox ?? icon.viewBox ?? '0 0 24 24';
  const resolvedFill = fill ?? icon.fill ?? 'none';
  const resolvedStroke = stroke ?? icon.stroke ?? 'none';
  const resolvedStrokeWidth = strokeWidth ?? icon.strokeWidth ?? '0';

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox={resolvedViewBox}
      fill={resolvedFill}
      stroke={resolvedStroke}
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={combinedClasses}
      aria-hidden="true"
    >
      {icon.elements}
    </svg>
  );
}
